import React from 'react';
import Label from '../../context/Label/Label';

import styles from './Progress.module.scss';

function Progress({
  percent,
  showText,
  color = '#333333',
  height = '3px',
  className,
}) {
  const _className = [styles.Progress];
  className && _className.push(className);

  return (
    <div className={_className.join(' ')}>
      <div
        className={styles.Progress__bar__bg}
        style={{ backgroundColor: `${color}50`, height }}
      >
        <div
          className={styles.Progress__bar__fg}
          style={{
            width: `${percent}%`,
            backgroundColor: color,
          }}
        />
      </div>
      {showText && (
        <div className={styles.Progress__text} style={{ color }}>
          {percent}% <Label>completed</Label>
        </div>
      )}
    </div>
  );
}

export default Progress;
